import { createFileRoute, Outlet } from "@tanstack/react-router";

import { FlightSearchDataProvider } from "@/features/flights/contexts/FlightSearchDataContext";
import { FlightSortProvider } from "@/features/flights/contexts/FlightSortContext";

export const Route = createFileRoute("/_authenticated/flights")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <FlightSearchDataProvider>
      <FlightSortProvider>
        <Outlet />
      </FlightSortProvider>
    </FlightSearchDataProvider>
  );
}
